enum ColorMaterialType {
  Metallic = 'metallic',
  Standard = 'standard',
  Special = 'special',
  Pastel = 'pastel',
  Unilack = 'unilack',
}

export default ColorMaterialType;
